<template>
  <!-- Toolbar used to cycle through loaded audits -->
  <v-toolbar color="primary" fixed flat>
    <v-toolbar-title>
      <h3>{{ title }}</h3>
    </v-toolbar-title>
    <v-spacer />
    <v-btn icon @click="$emit('handlePrevItem', item.index )" :disabled="item.index == 0">
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    {{item.index + 1}}/{{totalItems}}
    <v-btn
      icon
      @click="$emit('handleNextItem', item.index )"
      :disabled="item.index + 1 >= totalItems"
    >
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
    <v-btn icon @click="$emit('exit', false)">
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "AuditToolbar",
  props: ["title", "item", "totalItems"]
};
</script>

<style>
</style>
